import { nonAccentVietnamese } from '@iso/lib/helpers/utility';

import teamActions from './actions';

const initialState = {
  teams: [],
  team: {},
  total: 0,
  pageSize: 10,
  totalPages: 0,
  isFetched: false,
  loading: false,
  errorMessage: '',
  status: '',
  customerStats: [],
  ticketStats: [],
  feedbackStats: [],
};

export default function teamReducer(state = initialState, action) {
  switch (action.type) {
    case teamActions.GET_TEAM:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case teamActions.SET_TEAM:
      return {
        ...state,
        team: action.payload,
        loading: false,
        isFetched: true,
      };
    case teamActions.SET_TEAMS:
      return {
        ...state,
        teams: action.payload.data.map(item => {
          return {
            ...item,
            keyword: `${nonAccentVietnamese(item.name)}`,
          };
        }),
        total: action.payload.total,
        pageSize: action.payload.pageSize,
        totalPages: action.payload.totalPages,
        isFetched: true,
      };
    case teamActions.CREATE_TEAM:
      return {
        ...state,
        teams: [
          {
            ...action.payload,
            keyword: `${nonAccentVietnamese(action.payload.name)}`,
          },
          ...state.teams,
        ],
        total: state.total + 1,
        status: 'CREATED',
        team: {},
      };
    case teamActions.UPDATE_TEAM:
      return {
        ...state,
        teams: [
          ...state.teams.map(team => {
            return team.id === action.payload.id ? {
              ...team,
              ...action.payload,
              keyword: `${nonAccentVietnamese(action.payload.name)}`,
            } : team;
          })
        ],
        status: 'UPDATED',
      };
    case teamActions.DELETE_TEAM:
      return {
        ...state,
        teams: state.teams.filter(team => team.id !== action.payload.id),
        total: state.total - 1,
        status: 'DELETED',
      };
    case teamActions.TEAM_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
        isFetched: true,
        loading: false,
      };

    case teamActions.RESET_TEAM_STATUS:
      return {
        ...state,
        errorMessage: '',
        status: '',
      };

    case teamActions.SET_TEAM_CUSTOMER_STATS:
      return {
        ...state,
        customerStats: action.payload,
      };

    case teamActions.SET_TEAM_TICKET_STATS:
      return {
        ...state,
        ticketStats: action.payload,
      };

    case teamActions.SET_TEAM_FEEDBACK_STATS:
      return {
        ...state,
        feedbackStats: action.payload,
      };

    default:
      return state;
  }
}
